// =====================================================================
// Empleados / técnicos (capa de operaciones). Matchea enum/modelo Prisma.
// =====================================================================

/** Rol/función del empleado (perfil). Matchea enum Prisma EmployeeRole. */
export type EmployeeRole = 'ADMIN' | 'TECNICO' | 'SOPORTE';

/** Nivel/grado del técnico (score). Matchea enum Prisma EmployeeLevel. */
export type EmployeeLevel = 'A' | 'B' | 'C';

/**
 * Habilidades/funciones válidas del empleado (multi-tag). Son las de la
 * operación de Osito: quién vende, quién entrega, quién despacha, quién cobra.
 * Un empleado puede tener varias (el mensajero fijo a veces también despacha).
 */
export const EMPLOYEE_SKILLS = [
  'vendedor',
  'mensajero',
  'despacho',
  'caja',
  'mayoreo',
] as const;
export type EmployeeSkill = (typeof EMPLOYEE_SKILLS)[number];

/**
 * Perfil de empleado/técnico. La foto vive en el storage de medios
 * (`fotoUrl` es servible vía GET /media/*). `userId` vincula —si existe— la
 * cuenta de login del empleado (1:1 opcional).
 */
export interface Employee {
  id: string;
  nombre: string;
  telefono?: string | null;
  fotoUrl?: string | null;
  rol: EmployeeRole;
  activo: boolean;
  habilidades: string[];
  nivel?: EmployeeLevel | null;
  lastLat?: number | null;
  lastLng?: number | null;
  lastLocationAt?: string | null;
  userId?: string | null;
  createdAt: string;
  updatedAt: string;
}
